var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1443.061 1249.993"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3777e3",
    d: "M240.525 1249.993l240.492-416.664h962.044l-240.514 416.664z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf63",
    d: "M962.055 833.329h481.006L962.055 0H481.017z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#11a861",
    d: "M0 833.329l240.525 416.664 481.006-833.328L481.017 0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAwIiBoZWlnaHQ9IjIxNjYiIHZpZXdCb3g9IjAgMCAxNDQzLjA2MSAxMjQ5Ljk5MyI+PHBhdGggZmlsbD0iIzM3NzdlMyIgZD0iTTI0MC41MjUgMTI0OS45OTNsMjQwLjQ5Mi00MTYuNjY0aDk2Mi4wNDRsLTI0MC41MTQgNDE2LjY2NHoiLz48cGF0aCBmaWxsPSIjZmZjZjYzIiBkPSJNOTYyLjA1NSA4MzMuMzI5aDQ4MS4wMDZMOTYyLjA1NSAwSDQ4MS4wMTd6Ii8+PHBhdGggZmlsbD0iIzExYTg2MSIgZD0iTTAgODMzLjMyOWwyNDAuNTI1IDQxNi42NjQgNDgxLjAwNi04MzMuMzI4TDQ4MS4wMTcgMHoiLz48L3N2Zz4=";
export { SvgGoogleDrive as ReactComponent };